import { css, jsx } from "@emotion/react"
import styled from "@emotion/styled"
import { Button } from "matsuri-ui"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"
import { Header } from "@/components/Header/Header"

const HeaderTitle = styled.h2`
    font-size: 20px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
    padding: 10px;
`

const HiddenButton = () => (
    <Button
        css={css`
            visibility: hidden;
        `}
    />
)

interface TroubleReportHeaderProps {
    LeftButton?: () => jsx.JSX.Element
    RightButton?: () => jsx.JSX.Element
}

export const TroubleReportHeader = ({
    LeftButton = HiddenButton,
    RightButton = HiddenButton
}: TroubleReportHeaderProps) => {
    const { t } = useTranslation()
    return (
        <Header
            css={css`
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: ${theme.spacing}px ${theme.spacing * 2}px;
                padding-top: calc(
                    ${theme.spacing}px + env(safe-area-inset-top, 0px)
                );
            `}
        >
            <LeftButton />
            <HeaderTitle>{t("トラブル報告")}</HeaderTitle>
            <RightButton />
        </Header>
    )
}
